module.exports = __webpack_public_path__ + "img/column.e2f91fce.webp";